export const AUTH = {
  GET_URL: 'GET_URL',
  GET_TOKEN: 'GET_TOKEN',
};
